import React, { useEffect, useState, useContext } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import { handleDatePicker } from '../../../../../Functions/apis';
import axiosInstance from '../../../../../services/AxiosInstance';
import ScheduleInterview from './ScheduleInterview';
import swal from "sweetalert";
import { userContext } from '../../../../../contextProvider/Authentication';
import InputField from '../../../../../components/InputField';

const IndividualCandidate = () => {

    const { id, purl } = useParams();
    const history = useHistory();
    const [data, setData] = useState();
    const [profile, setProfile] = useState();
    const [modal, setModal] = useState(false);
    const [rejReason, setRejReason] = useState({ show: false });
    const [input, setInput] = useState({});

    const { user } = useContext(userContext);

    let url = purl ? `candidate-profile/${purl}/${id}/` : `can-applyjob/emp-candidate/${id}/`;

    useEffect(() => {
        axiosInstance.get(url)
            .then(res => {
                if (res?.status === 200) setData(res.data.results)
            })
        axiosInstance(`user/profile_percentage/${id}`, { method: "GET", }).then(res => setProfile(res?.data))
        // eslint-disable-next-line
    }, [user]);

    const handleInput = (e, name, type) => {
        if (type === "dropdown") setInput({ ...input, [name]: e });
        else setInput({ ...input, [e.target.name]: e.target.value });
    }

    const handleSubmit = () => {
        input['workflow'] = input.interview_type.id;
        input['interview_time'] = handleDatePicker(new Date(input.interview_time))
        axiosInstance(url, { method: "PUT", data: input })
            .then(res => {
                if (res?.status === 200) {
                    setModal(false);
                    axiosInstance(
                        "candidate-job-reminder/", {
                        method: "POST",
                        data: { "id": data?.user, "jid": id }
                    }).then(res => {
                        if (res.status === 200) {
                            swal("", "Interview scheduled for the candidate", "success", { button: "Ok!", })
                            history.push('/employer/company-manage-job')
                        }
                    })
                }
            }).catch(err => { console.log('err : ', err, err.response); })
    }

    const handleHire = (st, time) => {
        axiosInstance(url, {
            method: "PATCH",
            data: {
                "status": st,
                "rej_reason": rejReason?.rej_reason || "",
                [time]: "yes",
            }
        }).then(res => {
            if (res?.status === 200) {
                swal("Thank you", "", "success", { button: "Ok!", })
                history.push('/employer/company-manage-job')
            }
        }).catch(err => {
            swal("", err?.response?.data?.join(","), "error", { button: "Ok!", })
        })
        setRejReason({ ...rejReason, show: false });
    }

    return (
        <>
            {
                modal &&
                <ScheduleInterview
                    setModal={setModal}
                    modal={modal}
                    input={input}
                    handleInput={handleInput}
                    handleSubmit={handleSubmit}
                />
            }
            <div className="page-content bg-white">
                <div className="content-block">
                    <div className="section-full bg-white p-t50 p-b20">
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-3 col-lg-4 m-b30">
                                    <div className="sticky-top">
                                        <div className="candidate-info company-info">
                                            <div className="candidate-detail text-center">
                                                <div className="canditate-des">
                                                    <Link to={"#"}>
                                                        <img alt="" src={data?.pimg} />
                                                    </Link>

                                                </div>
                                                <div className="candidate-title">
                                                    <h4 className="m-b5"><Link to={"#"}>{data?.name}</Link></h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-9 col-lg-8 m-b30">
                                    <div className="candidate-bx">
                                        <div className="candidate-bx-title">
                                            <div className="row">
                                                <div className="col-6">
                                                    <h5 className="font-weight-700 m-b5">Personal Information</h5>
                                                </div>
                                                <div className="col-6 text-right"><Link to="#" onClick={() => history.goBack()} className="site-button right-arrow button-sm float-right">Back</Link></div>
                                            </div>
                                        </div>
                                        <div className="candidate-bx-detail">
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Email</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-8">
                                                    <label>{data?.email}</label>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Description</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-8">
                                                    <label>{data?.description}</label>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Degrees</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-8">
                                                    <label>{data?.degrees?.join(', ')}</label>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Skills</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-8">
                                                    <label>{data?.skills?.join(', ')}</label>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Experiences</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-8">
                                                    <label>{data?.experiences?.join(', ')}</label>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Trainings</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-8">
                                                    <label>{data?.trainings?.join(', ')}</label>
                                                </div>
                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>Languages</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-8">
                                                    <label>{data?.languages?.join(', ')}</label>
                                                </div>

                                                <div className="col-md-4">
                                                    <div className="form-group">
                                                        <label>CV</label>
                                                    </div>
                                                </div>
                                                <div className="col-md-8">
                                                    <Link to={`/candidate-cv/${data?.user}`} >Download CV</Link>
                                                </div>
                                                {profile &&
                                                    <>
                                                        <div className="col-md-4">
                                                            <div className="form-group">
                                                                <label>Profile Updated</label>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-8">
                                                            <label>{profile}%</label>
                                                        </div>
                                                    </>
                                                }
                                            </div>
                                            {/* {
                                                (data?.status === 'ap') ?
                                                    <button className="site-button" onClick={() => setModal(true)}>Schedule Interview</button>
                                                    : (data?.status === "is") ? "Interview has been scheduled. Please check you mail."
                                                        : "Waiting for JOC to approve the candidate Application."
                                            } */}
                                            {
                                                (user?.role === 2 || user?.role === 3) ?
                                                    <>
                                                        {(data?.status === 'r') && "The candidate has been rejected."}
                                                        {(data?.status === 'ap') && <button className="site-button" onClick={() => setModal(true)}>Schedule Interview</button>}
                                                        {(data?.status === 'is') && "The candidate has been scheduled for interview."}
                                                    </>
                                                    :
                                                    ""
                                            }
                                            {
                                                data?.status === 'is' &&
                                                <div className='mt-2'>
                                                    <button
                                                        className="site-button"
                                                        onClick={() => handleHire("h", "hire_time")}
                                                        title="Click here to hire candidate"
                                                    >
                                                        Hire Candidate
                                                    </button>
                                                    <button
                                                        className="site-button btn-danger ml-3"
                                                        onClick={() => setRejReason({ ...rejReason, show: true })}
                                                        title="Click here to reject candidate"
                                                    >
                                                        Reject Candidate
                                                    </button>
                                                </div>
                                            }
                                            {
                                                data?.status === "h" &&
                                                <span className='text-danger'> Candidate has been hired</span>
                                            }
                                            {
                                                rejReason?.show &&
                                                <div className="mt-2">
                                                    <InputField
                                                        label="Reason for rejection"
                                                        name="rej_reason"
                                                        textType='textarea'
                                                        value={rejReason?.rej_reason}
                                                        onChange={(e) => setRejReason({ ...rejReason, [e.target.name]: e.target.value })}
                                                        placeholder="Enter reason for rejection"
                                                    />
                                                    <button
                                                        className="site-button btn-danger mt-3"
                                                        onClick={() => handleHire("r", "rej_time")}
                                                        title="Click here to reject candidate"
                                                    >
                                                        Submit
                                                    </button>
                                                </div>
                                            }

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default IndividualCandidate;